import { createSlice } from "@reduxjs/toolkit";
import _ from "lodash";
import Api from "../../../lib/api";
import configureStore from "../../../app/store";

export const commentsList = "commentList";

const initialState = {
    comments: [],
    pagingObject: {
        pageCount: 0,
        totalRecordCount: 0,
    },
};
let tripsId;
const commentsSlice = createSlice({
    name: commentsList,
    initialState,
    reducers: {
        getComments: (state, { payload }) => {
            const { entities } = payload;

            const arrComment = Object.values(entities.comments);
            state.comments.unshift(...arrComment);
            state.comments = _.sortBy(state.comments, (value) => value.attributes.createdAt);

            if (payload.pageIndex > 0 && payload.pageIndex !== undefined) {
                state.pageIndex = payload.pageIndex;
            } else {
                state.pageIndex = payload.meta.pageCount;
            }
            state.pagingObject.totalRecordCount = payload.meta.totalRecordCount;
        },
        addingLastComment: (state, { payload }) => {
            state.comments = payload;
        },
        clearCommentStates: (state, { payload }) => initialState,
    },
});
export const { getComments, clearCommentStates, addingLastComment } = commentsSlice.actions;
export default commentsSlice.reducer;

export const commentsSelectors = () => (state) => state[commentsList];

export const getAllComments = (tripId, pageSize = 4, pageIndex) => {
    const store = configureStore;
    const commentListLength = store.getState().commentList.comments;
    const commentRecordCount = store.getState().commentList.pagingObject.totalRecordCount;
    tripsId = tripId;
    return async (dispatch) => {
        try {
            if (
                commentRecordCount &&
                commentRecordCount > 0 &&
                commentRecordCount > commentListLength.length
            ) {
                const reduce = commentRecordCount - commentListLength.length;
                if (reduce < 4) {
                    pageSize = reduce;
                }
            }
            const response = await Api.get(`trips/${tripId}/comments`, {
                params: {
                    ...(pageIndex && { "page[number]": pageIndex - 1 }),
                    ...(pageSize && { "page[size]": pageSize }),
                    sort: "-id",
                },
            });
            dispatch(getComments({ ...response, pageIndex: pageIndex - 1 }));
        } catch (errors) {
            console.log(errors);
        }
    };
};
